//货主船运需求

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 海事费用
 */
class MaritimeAffairsFee extends UltMeta {
    SHIPPERS_BEAR_UPSTREAM = new Meta(1, "货主承担上游");
    SHIPPERS_BEAR_DOWNSTREAM = new Meta(2, "货主承担下游");
    SHIPPERS_BEAR_BOTH_PORTS = new Meta(3, "货主承担两港");
    SHIPPERS_NOT_RESPONSIBLE = new Meta(4, "货主不承担");
}

export const MARITIME_AFFAIRS_FEE = new MaritimeAffairsFee();
